export default __webpack_public_path__ + "static/media/image.acaa74a5.svg";